import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { contactInfo } from '../data/mock';
import { Phone, Mail, Clock, Printer } from 'lucide-react';

const ContactPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        {/* Hero Banner */}
        <div className="relative h-[250px] bg-[#FFDA00]">
          <img
            src="https://images.unsplash.com/photo-1423666639041-f56000c27a9a?w=1600&h=400&fit=crop"
            alt="Contact us"
            className="w-full h-full object-cover opacity-40"
          />
          <div className="absolute inset-0 flex items-center justify-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white">Contact Us</h1>
          </div>
        </div>

        {/* Contact Content */}
        <section className="py-12 px-4 bg-[#f5f5f0]">
          <div className="max-w-6xl mx-auto">
            {/* Contact Info */}
            <div className="bg-white rounded-lg shadow-md p-8 max-w-2xl mx-auto">
              <h2 className="text-2xl font-bold text-[#FFDA00] mb-6">
                Get In Touch
              </h2>
              <p className="text-gray-600 mb-8">
                Have questions about our products or services? We&apos;d love to hear from you.
              </p>

              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-[#FFDA00]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <Phone className="w-5 h-5 text-[#FFDA00]" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800">Phone</h3>
                    <p className="text-gray-600">{contactInfo.phone}</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-[#FFDA00]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <Printer className="w-5 h-5 text-[#FFDA00]" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800">Fax</h3>
                    <p className="text-gray-600">{contactInfo.fax}</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-[#FFDA00]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <Mail className="w-5 h-5 text-[#FFDA00]" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800">Email</h3>
                    <div className="space-y-3 mt-2">
                      <div>
                        <p className="text-gray-800 font-medium">General Enquiry</p>
                        <p className="text-gray-600"><a href="mailto:info@agridirect.com.au" className="text-[#FFDA00] hover:underline">info@agridirect.com.au</a></p>
                      </div>
                      <div>
                        <p className="text-gray-800 font-medium">Export &amp; Sales</p>
                        <p className="text-gray-600">Saydul Alam Ruman - <a href="mailto:saydul@agridirect.com.au" className="text-[#FFDA00] hover:underline">saydul@agridirect.com.au</a></p>
                      </div>
                      <div>
                        <p className="text-gray-800 font-medium">Grower Accumulation</p>
                        <p className="text-gray-600">Nick Davies - <a href="mailto:nick@agridirect.com.au" className="text-[#FFDA00] hover:underline">nick@agridirect.com.au</a></p>
                      </div>
                      <div>
                        <p className="text-gray-800 font-medium">Export Documentation &amp; Logistics</p>
                        <p className="text-gray-600">Jasmin Robertson - <a href="mailto:Jasmin@agridirect.com.au" className="text-[#FFDA00] hover:underline">Jasmin@agridirect.com.au</a></p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-[#FFDA00]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <Clock className="w-5 h-5 text-[#FFDA00]" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800">Business Hours</h3>
                    <p className="text-gray-600">{contactInfo.hours}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Global Presence Map */}
            <div className="mt-12 bg-white rounded-lg shadow-md p-8">
              <h2 className="text-2xl font-bold text-[#FFDA00] mb-4 text-center">
                Our Global Presence
              </h2>
              <p className="text-gray-700 text-center mb-6">
                With offices located in Melbourne and Dhaka, ADA trades in Australia, Bangladesh, Dubai, Indonesia, and Pakistan.
              </p>
              <div className="flex justify-center">
                <img
                  src="https://customer-assets.emergentagent.com/job_af379c3c-fcd6-4194-be29-caf51021bd6a/artifacts/ybzffya0_contact-map.png"
                  alt="ADA Global Presence Map - Australia, Bangladesh, Dubai, Indonesia, Pakistan"
                  className="max-w-full h-auto rounded-lg"
                />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;
